import { Text } from 'react-native-paper'

export const SecondaryTitleText = ({ title }: { title: string }) => {
  return (
    <Text
      variant="titleLarge"
      style={{
        textAlign: 'center',
        color: 'gray',
        marginTop: 64,
        fontWeight: 'bold',
      }}
    >
      {title}
    </Text>
  )
}
